export class Step3 {
    constructor() {}

    intitule = 'stepper.form.dive_in.step2';
    getprincipales = 'form.dive_in.getprincipales';
    gettdminmax = 'form.dive_in.gettdminmax';
    gettdtype = 'form.dive_in.gettdtype';
	gettdlibre = 'form.dive_in.gettdlibre';
    getspan3 = 'form.dive_in.getspan3';
    getoui = 'form.dive_in.getoui';
    getnon = 'form.dive_in.getnon';
    getquantites = 'form.dive_in.getquantites';
    add = 'boutons.addline';
    remove = 'boutons.removeline';

    // intitule = 'stepper.form.dive_in.step3';
    section1 = 'form.dive_in.step4_section1';
    getnumlot = 'form.dive_in.getnumlot';
    getdescription = 'form.dive_in.getdescription';
    getquantite = 'form.dive_in.getquantite';
    getdateexecution = 'form.dive_in.getdateexecution';
    getdatelivraison = 'form.dive_in.getdatelivraison';
    getmotclef = 'form.dive_in.getmotclef_liste_avi_';
    getspan4 = 'form.dive_in.getspan4';
    getunlot = 'form.dive_in.getunlot';
    getplusieurslot = 'form.dive_in.getplusieurslot';
    gettouslots = 'form.dive_in.gettouslots';
    getspan18 = 'form.dive_in.getspan18';

}
